<template v-cloak>
    <!--会員登録・更新用パーツ-->
    <div class="pt400" id="pt400">
        <!--パンくずリスト-->
        <breadcrumb v-if="pageType == PAGE_INSERT" :decriptPage="$t('common.labels.memberRegistration')"></breadcrumb>
        <breadcrumb v-if="pageType == PAGE_UPDATE" :navListCustom="[{title:'マイページ', routerName: pt400Init.myPage, param: {pageNo: '81'}}, {title:$t('common.labels.confirmRegistInfor'), routerName: '', param: {}}]"></breadcrumb>

        <div class="">
            <!--画面タイトル-->
            <div class="itemTitle">
                <h2 v-if="pageType == PAGE_INSERT">{{$t('common.labels.memberRegistration')}}</h2>
                <h2 v-if="pageType == PAGE_UPDATE">{{$t('common.labels.myPgage')}}</h2>
            </div>
            <div class="inputCondition">
                <!--見出し-->
                <div class="insertTitle">
                    <h3 v-if="pageType == PAGE_INSERT">{{$t('common.labels.memberRegistrationForm')}}</h3>
                    <h3 v-if="pageType == PAGE_UPDATE">{{$t('common.labels.confirmRegistInfor')}}</h3>
                </div>
                <!--エラーメッセージ表示-->
                <!--　errorMsgFlg == 1の場合は mapMsg を上部に表示しない-->
                <div class="errorMessage">
                    <message :listMess="listMessValid" :mapMsg="pt400Init.errorMsgFlg == 1 ? [] : mapMessValid" :idScreen="PT400_PART"/>
                </div>

                <template v-if="isErrorFlg == 0">

                <!--メッセージ表示-->
                <div class="message" v-if="report != ''">
                    <span>{{report}} </span>
                </div>

                <template v-if="pageType == PAGE_UPDATE || (!isMailAuthSendFlg && !isMailAuthErr)">
                    <template v-if="pageType == PAGE_INSERT && pt400Init.mailAuthenticationFlg == 1 && !pt400Request.authUuid">
                        <!-- 説明27-->
                        <div class="explain1" v-html="pt400Init.descriptionInfo['27']"></div>
                    </template>
                    <template v-else>
                        <!-- 説明１-->
                        <div class="explain1" v-html="pt400Init.descriptionInfo['1']"></div>
                    </template>
                    <!-- 説明２-->
                    <p class="mailMessage" v-if="mailMessage1 !='' || mailMessage2 !=''">
                        <span class="mailMessage1" v-if="mailMessage1 !=''" v-html="mailMessage1"></span>
                        <br v-if="mailMessage1 !='' && mailMessage2 !=''">
                        <span class="mailMessage2" v-if="mailMessage2 !=''" v-html="mailMessage2"></span>
                    </p>
                    <p class="explain2"  v-if="pt400Init.customerGroupFlg == 1 && (pt400Request.customerGroup == null || pt400Request.customerGroup =='') && pageType == PAGE_UPDATE && pt400Init.siteKbn == 'B'">
                        <span>
                            {{($t('pt400.labels.customerGroup')).replace("{0}",pt400Init.analysisTitle)}}
                        </span>
                    </p>
                    <div class="displayNone">
                        <span id="mail_confirm_lbl">{{$t('pt400.labels.subMailAddress')}}</span>
                    </div>
                </template>

                <!--メール認証オプションを利用している and メール認証をしていない場合-->
                <template v-if="pageType == PAGE_INSERT && pt400Init.mailAuthenticationFlg == 1 && !pt400Request.authUuid">
                    <!-- 認証メール送信前 -->
                    <template v-if="!isMailAuthSendFlg">
                        <div class="customer">
                            <div class="mailLine">
                                <div class="label">
                                    <label :class="pageType == PAGE_INSERT?'required':'verticalAlignTop'">
                                        <span id="mail_lbl">{{$t('common.labels.mailAddress')}}</span>
                                    </label>
                                </div>
                                <div class="input" >
                                    <span v-if="pt400Init.errorMsgFlg == 1 && getFieldError('mail')" class="inlineError" v-html="getFieldError('mail')"></span>
                                    <input-check type="text" class="mailInput mode" @on-input-change="change()" id="mail" name="mail" maxlength="100" size="35" v-model="pt400Request.mail"/>
                                    <!--項目説明マスタ[4]-->
                                    <div v-html="pt400Init.descriptionInfo['4']"></div>
                                </div>
                            </div>
                            <div class="mailConfirm">
                                <div class="label">
                                    <label :class="pageType == PAGE_INSERT?'required':'verticalAlignTop'">
                                        <span id="mailConnfirm_lbl">{{$t('common.labels.mailAddressConfirm')}}</span>
                                    </label>
                                </div>
                                <div class="input" >
                                    <span v-if="pt400Init.errorMsgFlg == 1 && getFieldError('mail_confirm')" class="inlineError " v-html="getFieldError('mail_confirm')"></span>
                                    <!--項目説明マスタ[5]-->
                                    <div v-html="pt400Init.descriptionInfo['5']"></div>
                                    <!--確認メールアドレス入力-->
                                    <input-check type="text" class="mailConfirmInput mode" @on-input-change="change()" id="mail_confirm" name="mail_confirm" maxlength="100" size="35" v-model="pt400Request.mail_confirm"/>
                                </div>
                            </div>
                        </div>
                        <!--プライバシーポリシーリンク-->
                        <p class="noteLink">
                            <span v-html="pt400Init.descriptionInfo['21']"></span>
                            <router-link class="blank" target="_blank" :to="{ name: SiteConstants.PG010MAIN, query:{ pageNo:70}}">
                                {{$t('common.labels.noteLink')}}
                            </router-link>
                            <span v-html="pt400Init.descriptionInfo['22']"></span>
                        </p>
                        <!--登録ボタン-->
                        <div id="btn_roll2">
                            <a class="btnSubmit" @click="confirmDoAuth()">{{$t('common.buttons.signup')}}</a>
                        </div>
                    </template>

                    <!-- 認証メール送信後 -->
                    <template v-else>
                        <div class="section-inner">
                            <!--項目説明マスタ[25]-->
                            <div class="explain1" v-html="pt400Init.descriptionInfo['25']"></div>
                            <!-- 説明２-->
                            <p class="mailMessage" v-if="mailMessage1 !='' || mailMessage2 !=''">
                                <span class="mailMessage1" v-if="mailMessage1 !=''" v-html="mailMessage1"></span>
                                <br v-if="mailMessage1 !='' && mailMessage2 !=''">
                                <span class="mailMessage2" v-if="mailMessage2 !=''" v-html="mailMessage2"></span>
                            </p>
                            <!--TOPボタン-->
                            <div id="btn_roll2" class="mt-3">
                                <router-link :to="generateLinkParams(1,pt400Init.topPage)" class="btnCancel">
                                    {{$t('common.buttons.backToTopPage')}}
                                </router-link>
                            </div>
                        </div>
                    </template>
                </template>

                <!--メール認証オプションを利用している and メール認証がエラーの場合-->
                <template v-else-if="pageType == PAGE_INSERT && pt400Init.mailAuthenticationFlg == 1 && pt400Request.authUuid && isMailAuthErr">
                    <div class="section-inner">
                        <!-- 項目説明マスタ[26] -->
                        <div class="explain1" v-html="pt400Init.descriptionInfo['26']"></div>
                        <!-- 会員登録ボタン -->
                        <div id="btn_roll2" class="mt-3">
                            <router-link :to="generateLinkParams(8,pt400Init.customePage)" class="btnSubmit">
                                {{$t('common.buttons.goToRegisterMember')}}
                            </router-link>
                        </div>
                    </div>
                    <!-- TOPボタン -->
                    <div id="btn_roll3" class="mt-3">
                        <router-link :to="generateLinkParams(1,pt400Init.topPage)" class="btnCancel">
                            {{$t('common.buttons.backToTopPage')}}
                        </router-link>
                    </div>
                </template>

                <!--メール認証オプションを利用していない or メール認証を行った場合-->
                <template v-else>
                    <div class="customer">
                        <!-- 営業許可番号 ユニコカスタマイズ項目 -->
                        <div class="eigyokyoLine" v-if="checkUnico(1)">
                            <div class="label">
                                <label :class="pageType == PAGE_INSERT?'required':'verticalAlignTop'" id="eigyokyoNo_lbl">
                                    <span>{{$t('pt400.labels.eigyokyoNo')}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <span v-if="pt400Init.errorMsgFlg == 1 && getFieldError('eigyokyoNo')" class="inlineError" v-html="getFieldError('eigyokyoNo')"></span>
                                <input-check type="text" id="eigyokyoNo" class="eigyokyoNoInput" name="eigyokyoNo" maxlength="50" size="35" v-model="pt400Request.unicoEigyokyoNo"/>
                                <div class="eigyokyoNoInfo1 mt-3">{{$t('pt400.labels.eigyokyoNoInfo1')}}</div>
                                <div class="eigyokyoNoInfo2">{{$t('pt400.labels.eigyokyoNoInfo2')}}</div>
                            </div>
                        </div>
                        <!--会員ID -->
                        <div class="kaiinIdLine" v-if="pt400Init.kokyakuCdHatuFlg == 1">
                            <div class="label">
                                <label :class="pageType == PAGE_INSERT?'required':'verticalAlignTop'" id="kaiinId_lbl">
                                    <span>{{$t('pt400.labels.kaiinId')}}</span>
                                </label>
                            </div>
                            <div class="input">
                            <template>
                                <span v-if="pt400Init.errorMsgFlg == 1 && getFieldError('kaiinId')" class="inlineError" v-html="getFieldError('kaiinId')"></span>
                                <input-check type="text" id="kaiinId" class="kaiinIdInput code" @on-input-change="change()" name="kaiinId" maxlength="15" size="35" v-model="pt400Request.kokyakuCd" :disabled="pageType != PAGE_INSERT"/>
                                <!--重複チェックボタン-->
                                <input v-if="pageType == PAGE_INSERT" id="nav-search-button" type="button" @click="check()" :value="$t('pt400.labels.duplicationcheck')">
                                    <span class="okMessage" v-if="pt400Request.kaiinCheck == 0">{{$t('pt400.labels.checkConfirm')}}</span>
                                    <span class="err" v-if="pt400Request.kaiinCheck == 1">{{$t('pt400.labels.checkConfirmErr')}}</span>
                                    <span class="checkNull" v-if="pt400Request.kaiinCheck == 2">{{$t('pt400.labels.checkCnfirmNull')}}</span>
                            </template>
                            <!--項目説明マスタ[24]-->
                            <div v-if="pageType == PAGE_INSERT" v-html="pt400Init.descriptionInfo['24']"></div>
                            </div>
                        </div>
                        <!-- 会員ID 表示のみ -->
                        <div v-if="checkUnico(0) && pageType == PAGE_UPDATE">
                            <div class="label">
                                <label class="verticalAlignTop" id="kaiinId_lbl">
                                    <span>{{$t('pt400.labels.kaiinId')}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <span class="displayKaiinId">{{pt400Request.kokyakuCd}}</span>
                            </div>
                        </div>
                        <div class="mailLine" v-if="!(pt400Init.entetsuFlg == 1 && (pageType == PAGE_INSERT || pageType == PAGE_UPDATE))">
                            <div class="label">
                                <label :class="pageType == PAGE_INSERT?'required':'verticalAlignTop'">
                                    <span id="mail_lbl">{{$t('common.labels.mailAddress')}}</span>
                                </label>
                            </div>
                            <div class="input" >
                                <span v-if="pt400Init.errorMsgFlg == 1 && getFieldError('mail')" class="inlineError" v-html="getFieldError('mail')"></span>
                                <input-check type="text" class="mailInput mode" @on-input-change="change()" id="mail" name="mail" maxlength="100" size="35" v-model="pt400Request.mail" :disabled="(pt400Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false)
                                                                                                                                                                                                    || (pageType == PAGE_INSERT && pt400Init.mailAuthenticationFlg == 1 && pt400Request.authUuid && !isMailAuthErr)"/>
                                <input-check v-if="pageType == PAGE_UPDATE" type="hidden" id="mailOld" @on-input-change="change()" name="mailOld" v-model="pt400Request.mailOld" />
                                <!--項目説明マスタ[4]-->
                                <div v-html="pt400Init.descriptionInfo['4']"></div>
                            </div>
                        </div>
                        <div class="mailConfirm" v-if="!(pt400Init.entetsuFlg == 1 && (pageType == PAGE_INSERT || pageType == PAGE_UPDATE))">
                            <div class="label">
                                <label :class="pageType == PAGE_INSERT?'required':'verticalAlignTop'">
                                    <span>{{$t('common.labels.mailAddressConfirm')}}</span>
                                </label>
                            </div>
                            <div class="input" >
                                <span v-if="pt400Init.errorMsgFlg == 1 && getFieldError('mail_confirm')" class="inlineError" v-html="getFieldError('mail_confirm')"></span>
                                <!--項目説明マスタ[5]-->
                                <div v-html="pt400Init.descriptionInfo['5']"></div>
                                <!--確認メールアドレス入力-->
                                <input-check type="text" class="mailConfirmInput mode" @on-input-change="change()" id="mail_confirm" name="mail_confirm" maxlength="100" size="35" v-model="pt400Request.mail_confirm" :disabled="pt400Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false" readonly @on-focus="removeReadonly"/>
                            </div>
                        </div>
                        <div class="mailLine" v-if="pt400Init.entetsuFlg == 1 && (pageType == PAGE_INSERT || pageType == PAGE_UPDATE)">
                            <div class="label">
                                <label :class="pageType == PAGE_INSERT?'required':'verticalAlignTop'">
                                    <span id="mail_lbl">{{$t('common.labels.mailAddress')}}</span>
                                </label>
                            </div>
                            <div class="input" >
                                <span v-if="pt400Init.errorMsgFlg == 1 && getFieldError('mail')" class="inlineError" v-html="getFieldError('mail')"></span>
                                <input-check type="text" class="mailInput mode" @on-input-change="change()" id="mail" name="mail" maxlength="100" size="35" v-model="pt400Request.mail" :disabled="(pt400Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false)
                                                                                                                                                                                                    || (pageType == PAGE_INSERT && pt400Init.mailAuthenticationFlg == 1 && pt400Request.authUuid && !isMailAuthErr)"/>
                                <input-check v-if="pageType == PAGE_UPDATE" type="hidden" id="mailOld" @on-input-change="change()" name="mailOld" v-model="pt400Request.mailOld" />
                                <!--項目説明マスタ[4]-->
                                <div v-html="pt400Init.descriptionInfo['4']"></div>
                            </div>
                            <div class="input" >
                                <span v-if="pt400Init.errorMsgFlg == 1 && getFieldError('mail_confirm')" class="inlineError" v-html="getFieldError('mail_confirm')"></span>
                                <!--項目説明マスタ[5]-->
                                <div v-html="pt400Init.descriptionInfo['5']"></div>
                                <!--確認メールアドレス入力-->
                                <input-check type="text" class="mailConfirmInput mode" @on-input-change="change()" id="mail_confirm" name="mail_confirm" maxlength="80" size="35" v-model="pt400Request.mail_confirm" :disabled="pt400Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false"/>
                            </div>
                        </div>
                        <template v-if="pt400Init.entetsuFlg == 1  && ikoPasswordDispFlg == 1 && pageType == PAGE_INSERT">
                            <div class="passLine">
                                <div class="label">
                                    <label>
                                        <span id="password_lbl">{{$t('pt400.labels.ikoPassword')}}</span>
                                    </label>
                                </div>
                                <div class="input">
                                    <span v-if="pt400Init.errorMsgFlg == 1 && getFieldError('password')" class="inlineError" v-html="getFieldError('password')"></span>
                                    <input-check type="password" name="password" size="20" class="passwordInput" @on-input-change="change()" maxlength="16" id="password" v-model="pt400Request.ikoPassword" readonly @on-focus="removeReadonly"/>
                                    <br/><br/>
                                    <!--項目説明マスタ[8]-->
                                    <div v-html="pt400Init.descriptionInfo['8']"></div>
                                    <!--確認パスワード入力-->
                                    <input-check type="password" name="passwordSub" size="20" maxlength="16" class="passwordSubInput" @on-input-change="change()" readonly @on-focus="removeReadonly" id="passwordSub" v-model="pt400Request.ikoPasswordSub" />
                                </div>
                            </div>
                        </template>
                        <template v-if="pt400Init.entetsuFlg != 1 || (pt400Init.entetsuFlg == 1 && pt400Init.entetsuKohojinFlg == 0) ">
                            <!-- 現在のパスワード(更新時)-->
                            <div class="passLine" v-if="pt400Init.passChangeOption == 0 && pageType == PAGE_UPDATE ">
                                <div class="label">
                                    <label>
                                        <span id="prePassword_lbl">{{$t('pt400.labels.currentPass')}}</span>
                                    </label>
                                </div>
                                <div class="input">
                                    <span v-if="pt400Init.errorMsgFlg == 1 && getFieldError('prePassword')" class="inlineError" v-html="getFieldError('prePassword')"></span>
                                    <input-check type="password" name="pre_password" size="20" maxlength="16" id="prePassword" @on-input-change="change()" class="prePasswordInput" v-model="pt400Request.prePassword" readonly @on-focus="removeReadonly" />
                                    <!--項目説明マスタ[6]-->
                                    <div v-html="pt400Init.descriptionInfo['6']"></div>
                                </div>
                            </div>
                            <div class="NewPassLine" v-if="pt400Init.passChangeOption == 0 && pt400Init.syouninOption == 0 || pt400Init.passChangeOption == 0 && pt400Init.syouninOption == 1 && pageType == PAGE_UPDATE  || pt400Init.passChangeOption == 1 && pt400Init.syouninOption == 0 && pageType == PAGE_INSERT">
                                <div class="label">
                                    <label :class="pageType == PAGE_INSERT?'required':'verticalAlignTop'">
                                        <span id="password_lbl">{{$t('pt400.labels.newPass')}}</span>
                                    </label>
                                </div>
                                <div class="input">
                                    <span v-if="pt400Init.errorMsgFlg == 1 && getFieldError('password')" class="inlineError" v-html="getFieldError('password')"></span>
                                    <input-check type="password" name="password" size="20" class="passwordInput" @on-input-change="change()" readonly @on-focus="removeReadonly" maxlength="16" id="password" v-model="pt400Request.password" />
                                    <!--項目説明マスタ[7]-->
                                    <div v-html="pt400Init.descriptionInfo['7']"></div>
                                </div>
                            </div>
                            <div class="confirmPassLine" v-if="pt400Init.passChangeOption == 0 && pt400Init.syouninOption == 0 || pt400Init.passChangeOption == 0 && pt400Init.syouninOption == 1 && pageType == PAGE_UPDATE  || pt400Init.passChangeOption == 1 && pt400Init.syouninOption == 0 && pageType == PAGE_INSERT">
                                <div class="label">
                                    <label :class="pageType == PAGE_INSERT?'required':'verticalAlignTop'">
                                        <span id="passwordSub_lbl">{{$t('pt400.labels.passConfirm')}}</span>
                                    </label>
                                </div>
                                <div class="input">
                                    <span v-if="pt400Init.errorMsgFlg == 1 && getFieldError('passwordSub')" class="inlineError" v-html="getFieldError('passwordSub')"></span>
                                    <!--項目説明マスタ[8]-->
                                    <div v-html="pt400Init.descriptionInfo['8']"></div>
                                    <!--確認パスワード入力-->
                                    <input-check type="password" name="passwordSub" size="20" maxlength="16" class="passwordSubInput" @on-input-change="change()" readonly @on-focus="removeReadonly" id="passwordSub" v-model="pt400Request.passwordSub" />
                                </div>
                            </div>
                        </template>
                        <!-- 知ったきっかけ ユニコカスタマイズ項目 -->
                        <div class="cognitionLine" v-if="checkUnico(1)">
                            <div class="label">
                                <label :class="pageType == PAGE_INSERT?'required':'verticalAlignTop'" id="cognitionSelect_lbl">
                                    <span>{{$t('pt400.labels.cognition')}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <span v-if="pt400Init.errorMsgFlg == 1 && getFieldError('cognitionSelect')" class="inlineError" v-html="getFieldError('cognitionSelect')"></span>
                                <select v-model="pt400Request.unicoCognition" class="cognitionSelect" id="cognitionSelect" name="cognitionSelect"  @change="unicoCognitionChg(1)"> 
                                    <option v-for="cognition in pt400Init.unicoCognitionList" :key="cognition.KEY" :value="cognition.KEY">{{cognition.VALUE}}</option>
                                </select>
                            </div>
                        </div>
                        <!-- 知ったきっかけ詳細 ユニコカスタマイズ項目 -->
                        <template v-if="unicoCognitionDtlFlg">
                            <div class="cognitionLineDtl cognitionLineDtl1" v-if="pt400Request.unicoCognitionDtlTitle1">
                                <div class="label">
                                    <label class="optional" id="cognitionLineDtl1_lbl">
                                        <span>{{$t('pt400.labels.cognition')}}（{{pt400Request.unicoCognitionDtlTitle1}}）</span>
                                    </label>
                                </div>
                                <div class="input">
                                    <input-check type="text" id="cognitionLineDtlValue1" class="cognitionLineDtlValue cognitionLineDtlValue1" name="cognitionLineDtlValue1" maxlength="50" size="35" v-model="pt400Request.unicoCognitionDtlValue1"/>
                                    <div class="cognitionLineDtlInfo cognitionLineDtlInfo1 mt-3">{{unicoCognitionDtlInfo1}}</div>
                                </div>
                            </div>
                            <div class="cognitionLineDtl cognitionLineDtl2" v-if="pt400Request.unicoCognitionDtlTitle2">
                                <div class="label">
                                    <label class="optional" id="cognitionLineDtl2_lbl">
                                        <span>{{$t('pt400.labels.cognition')}}（{{pt400Request.unicoCognitionDtlTitle2}}）</span>
                                    </label>
                                </div>
                                <div class="input">
                                    <input-check type="text" id="cognitionLineDtlValue2" class="cognitionLineDtlValue cognitionLineDtlValue2" name="cognitionLineDtlValue2" maxlength="50" size="35" v-model="pt400Request.unicoCognitionDtlValue2"/>
                                    <div class="cognitionLineDtlInfo cognitionLineDtlInfo2 mt-3">{{unicoCognitionDtlInfo2}}</div>
                                </div>
                            </div>
                        </template>
                        <!-- 業種 ユニコカスタマイズ項目 -->
                        <div class="gyosyuLine" v-if="checkUnico(1)">
                            <div class="label">
                                <label :class="pageType == PAGE_INSERT?'required':'verticalAlignTop'" id="gyosyuSelect_lbl">
                                    <span>{{$t('pt400.labels.gyosyu')}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <span v-if="pt400Init.errorMsgFlg == 1 && getFieldError('gyosyuSelect')" class="inlineError" v-html="getFieldError('gyosyuSelect')"></span>
                                <select v-model="pt400Request.unicoGyosyu" class="gyosyuSelect" id="gyosyuSelect" name="gyosyuSelect"> 
                                    <option v-for="gyosyu in pt400Init.unicoGyosyuList" :key="gyosyu.KEY" :value="gyosyu.KEY">{{gyosyu.VALUE}}</option>
                                </select>
                            </div>
                        </div>
                        <!--お名前-->
                        <div class="nameLine">
                            <div class="label">
                                <div :class="'popup'"></div>
                                <label :class="pt400Init.nameEditFlg == 0?'required':''">
                                    <span>{{$t('pt400.labels.names'+common.stringNvl(pt400Init.siteKbn))}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <span v-if="pt400Init.errorMsgFlg == 1 && getFieldError('nm1')" class="inlineError entryName" v-html="getFieldError('nm1')"></span>
                                <label v-if="pt400Init.name2Flg == 1" for="nm1" id="nm1_lbl">{{$t('pt400.labels.surname'+common.stringNvl(pt400Init.siteKbn))}}</label>
                                <label v-else for="nm" id="nm_lbl">{{$t('pt400.labels.name1')}}</label>
                                <!--編集オプション：可の場合-->
                                <template v-if="pt400Init.nameEditFlg == 0">
                                    <input-check :class="pt400Init.name2Flg == 0?'width150':''"
                                                class="nm1Input"
                                                type="text" name="nm1" id="nm1" size="25" @on-input-change="change()"
                                                maxlength="50" 
                                                v-model="pt400Request.nm1" :disabled="pt400Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false"/>
                                </template>
                                <!--編集オプション：不可の場合-->
                                <template v-else>
                                    <input-check :class="pt400Init.name2Flg == 0?'width150':''"
                                                disabled class="backgroundColorBrightSilver"
                                                type="text" name="nm1" id="nm1" size="25"
                                                maxlength="50" 
                                                v-model="pt400Request.nm1" />
                                </template>
                                <template v-if="pt400Init.name2Flg == 1">
                                    <!--名 名前２利用フラグが利用の場合-->
                                    <label for="nm2" id="nm2_lbl">{{$t('pt400.labels.name2'+common.stringNvl(pt400Init.siteKbn))}}<span v-if="pt400Init.siteKbn == 'B' && pt400Init.nameEditFlg == 0" class="optionalInfo ml-2">{{$t('common.labels.optional')}}</span></label>
                                    <!--編集オプション：可の場合-->
                                    <template v-if="pt400Init.nameEditFlg == 0">
                                        <input-check type="text" name="nm2" id="nm2" class="nm2Input" @on-input-change="change()" size="25" maxlength="50" v-model="pt400Request.nm2" :disabled="pt400Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false" />
                                    </template>
                                    <!--編集オプション：不可の場合-->
                                    <template v-else>
                                        <input-check disabled class="backgroundColorBrightSilver" type="text" name="nm2" id="nm2" size="25" maxlength="50" v-model="pt400Request.nm2" />
                                    </template>
                                </template>

                                <template v-if="!checkUnico(0)">
                                    <!--名 名前3-->
                                    <label v-if="pt400Init.siteKbn == 'B'" for="nm2" id="nm3_lbl">{{$t('pt400.labels.name3'+common.stringNvl(pt400Init.siteKbn))}}<span v-if="pt400Init.nameEditFlg == 0" class="optionalInfo ml-2">{{$t('common.labels.optional')}}</span></label>
                                    <template v-if="pt400Init.siteKbn == 'B'">
                                        <!--編集オプション：可の場合-->
                                        <template v-if="pt400Init.nameEditFlg == 0">
                                            <input-check type="text" name="nm3" id="nm3" class="nm3Input" @on-input-change="change()" size="25" maxlength="50" v-model="pt400Request.nm3" :disabled="pt400Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false" />
                                        </template>
                                        <!--編集オプション：不可の場合-->
                                        <template v-else>
                                            <input-check disabled class="backgroundColorBrightSilver" type="text" name="nm3" id="nm3" size="25" maxlength="50" v-model="pt400Request.nm3" />
                                        </template>
                                    </template>
                                </template>

                                <!--項目説明マスタ[9]-->
                                <div v-if="pt400Init.nameEditFlg == 0" v-html="pt400Init.descriptionInfo['9']"></div>
                            </div>
                        </div>
                        <!--カナ-->
                        <div class="kanaLine">
                            <div class="label">
                                <label :class="pt400Init.kanaHissuFlg == 0 && pt400Init.nameEditFlg == 0?'optional':pt400Init.nameEditFlg == 0?'required':''">
                                    <span>{{$t('pt400.labels.name'+common.stringNvl(pt400Init.siteKbn))}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <span v-if="pt400Init.errorMsgFlg == 1 && getFieldError('kana1')" class="inlineError" v-html="getFieldError('kana1')"></span>
                                <label v-if="pt400Init.name2Flg == 1" for="kana1">{{$t('pt400.labels.surname'+common.stringNvl(pt400Init.siteKbn))}}</label>
                                <label v-else for="kana">{{$t('pt400.labels.name1')}}</label>
                                <span id="kana1_lbl" hidden>{{$t('pt400.labels.nameSurnameKana'+common.stringNvl(pt400Init.siteKbn))}}</span>
                                <span id="kana_lbl" hidden>{{$t('pt400.labels.name')}}</span>
                                <!--編集可-->
                                <template v-if="pt400Init.nameEditFlg == 0">
                                    <input-check :class="pt400Init.name2Flg == 0?'width150':''"
                                                class="kana1Input"
                                                type="text" name="kana1" size="25" @on-input-change="change()"
                                                id="kana1" maxlength="50" 
                                                v-model="pt400Request.kana1" :disabled="pt400Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false" />
                                </template>
                                <!--編集不可-->
                                <template v-else>
                                    <input-check :class="pt400Init.name2Flg == 0?'width150':''"
                                                disabled class="backgroundColorBrightSilver"
                                                type="text" name="kana1" size="25"
                                                id="kana1" maxlength="50" 
                                                v-model="pt400Request.kana1" />
                                </template>
                                <template v-if="pt400Init.name2Flg == 1">
                                    <!--名 名前２利用フラグが利用の場合-->
                                    <label for="kana2">{{$t('pt400.labels.name2'+common.stringNvl(pt400Init.siteKbn))}}<span v-if="pt400Init.siteKbn == 'B' && pt400Init.nameEditFlg == 0 && pt400Init.kanaHissuFlg == 1" class="optionalInfo ml-2">{{$t('common.labels.optional')}}</span></label>
                                    <span id="kana2_lbl" hidden>{{$t('pt400.labels.nameSurFirstNameKana'+common.stringNvl(pt400Init.siteKbn))}}</span>
                                    <!--編集可-->
                                    <template v-if="pt400Init.nameEditFlg == 0">
                                        <input-check type="text" name="kana2" size="25" class="kana2Input" @on-input-change="change()" id="kana2" maxlength="50" v-model="pt400Request.kana2" :disabled="pt400Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false" />
                                    </template>
                                    <!--編集不可-->
                                    <template v-else>
                                        <input-check disabled class="backgroundColorBrightSilver" type="text" name="kana2" size="25" id="kana2" maxlength="50" v-model="pt400Request.kana2" />
                                    </template>
                                </template>

                                <template v-if="!checkUnico(0)">
                                    <template v-if="pt400Init.siteKbn == 'B'">
                                        <!--名 名前3-->
                                        <label for="kana3">{{$t('pt400.labels.name3'+common.stringNvl(pt400Init.siteKbn))}}<span v-if="pt400Init.nameEditFlg == 0 && pt400Init.kanaHissuFlg == 1" class="optionalInfo ml-2">{{$t('common.labels.optional')}}</span></label>
                                        <span id="kana3_lbl" hidden>{{$t('pt400.labels.name3KanaB')}}</span>
                                        <!--編集可-->
                                        <template v-if="pt400Init.nameEditFlg == 0">
                                            <input-check type="text" name="kana3" size="25" class="kana3Input" @on-input-change="change()" id="kana3" maxlength="50" v-model="pt400Request.kana3" :disabled="pt400Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false" />
                                        </template>
                                        <!--編集不可-->
                                        <template v-else>
                                            <input-check disabled class="backgroundColorBrightSilver" type="text" name="kana3" size="25" id="kana3" maxlength="50" v-model="pt400Request.kana3" />
                                        </template>
                                    </template>
                                </template>
                                <!--項目説明マスタ[10]-->
                                <div v-if="pt400Init.nameEditFlg == 0" v-html="pt400Init.descriptionInfo['10']"></div>

                            </div>
                        </div>
                        <!--郵便番号-->
                        <div class="zipLine">
                            <div class="label">
                                <label class="required" id="zip_lbl">
                                    <span>{{$t('common.labels.postalCode')}}</span>
                                </label>
                            </div>
                            <div class="input">
                                    <span v-if="pt400Init.errorMsgFlg == 1 && getFieldError('zip')" class="inlineError" v-html="getFieldError('zip')"></span>
                                    <input-check type="text" class="zip zipInput" @on-input-change="change(),addrAutoInput('kokyaku')" name="zip" size="8" id="zip" maxlength="8" v-model="pt400Request.zip" :disabled="pt400Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false"/>
                                    <span class="btnAddSearch">
                                        <a @click="addrAutoInput('kokyaku')">{{$t('common.labels.addressSearch')}}</a>
                                    </span>
                                <!--項目説明マスタ[11]-->
                                <div v-html="pt400Init.descriptionInfo['11']"></div>
                            </div>
                        </div>
                        <!--都道府県 プルダウン設定オプション-->
                        <div class="kenLine" v-if="pt400Init.kenPulldownDispFlg == 1">
                            <div class="label">
                                <label class="required" id="kenCd_lbl">
                                    <span>{{$t('common.labels.prefectures')}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <span v-if="pt400Init.errorMsgFlg == 1 && getFieldError('kenCd')" class="inlineError" v-html="getFieldError('kenCd')"></span>
                                <select v-model="pt400Request.kenCd" class="kenCdSelect" @on-input-change="change()" id="kenCd" name="kenCd" :disabled="pt400Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false"> 
                                    <option v-for="kenCd in pt400Init.kenCdList" :key="kenCd.KEY" :value="kenCd.KEY">{{kenCd.VALUE}}</option>
                                </select>
                            </div>
                        </div>
                        <input type="hidden" v-model="pt400Request.kenCd" />
                        <!--住所1 -->
                        <div class="addr1Line">
                            <div class="label">
                                <label class="required" id="addr1_lbl">
                                    <span>{{$t('pt400.labels.city')}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <span v-if="pt400Init.errorMsgFlg == 1 && getFieldError('addr1')" class="inlineError" v-html="getFieldError('addr1')"></span>
                                <input-check type="text" class="addr1Input" @on-input-change="change()" name="addr1" size="72" id="addr1" maxlength="100" v-model="pt400Request.addr1" :disabled="pt400Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false"/>
                                <!--項目説明マスタ[18]-->
                                <div v-html="pt400Init.descriptionInfo['12']"></div>
                            </div>
                        </div>
                        <!--住所2 利用オプション-->
                        <div class="addr2Line" v-if="pt400Init.addr2Flg == 1">
                            <div class="label">
                                <label :class="pt400Init.addr2HissuFlg == 1?'required':'optional'" id="addr2_lbl" >
                                    <span>{{$t('pt400.labels.lessAddress')}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <span v-if="pt400Init.errorMsgFlg == 1 && getFieldError('addr2')" class="inlineError" v-html="getFieldError('addr2')"></span>
                                <input-check type="text" id="addr2" name="addr2" size="72" class="addr2Input" @on-input-change="change()" maxlength="100" v-model="pt400Request.addr2" :disabled="pt400Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false"/>
                                <!--項目説明マスタ[20]-->
                                <div v-html="pt400Init.descriptionInfo['13']"></div>
                            </div>
                        </div>
                        <!--住所3 利用オプション-->
                        <div class="addr3Line" v-if="pt400Init.addr3Flg == 1">
                            <div class="label">
                                <label :class="pt400Init.addr3HissuFlg == 1?'required':'optional'" id="addr3_lbl" >
                                    <span>{{$t('common.labels.optionLabel')}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <span v-if="pt400Init.errorMsgFlg == 1 && getFieldError('addr3')" class="inlineError" v-html="getFieldError('addr3')"></span>
                                <input-check type="text" id="addr3" name="addr3" size="72" class="addr3Input" @on-input-change="change()" maxlength="100" v-model="pt400Request.addr3" :disabled="pt400Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false"/>
                                <!--項目説明マスタ[22]-->
                                <div v-html="pt400Init.descriptionInfo['14']"></div>
                            </div>
                        </div>
                        <!--電話番号 -->
                        <div class="telLine">
                            <div class="label">
                                <label class="required" id="tel1_lbl">
                                    <span>{{$t('pt400.labels.phoneNumber')}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <span v-if="pt400Init.errorMsgFlg == 1 && getFieldError('tel1')" class="inlineError" v-html="getFieldError('tel1')"></span>
                                <input-check type="text" id="tel1" name="tel1" class="tel1Input code" @on-input-change="change()" size="18" maxlength="15" v-model="pt400Request.tel1" :disabled="pt400Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false"/>
                                <!--項目説明マスタ[15]-->
                                <div v-html="pt400Init.descriptionInfo['15']"></div>
                            </div>
                        </div>
                        <!--FAX -->
                        <div class="faxLine">
                            <div class="label">
                                <label class="optional" id="fax_lbl">
                                    <span>{{$t('common.labels.fax')}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <span v-if="pt400Init.errorMsgFlg == 1 && getFieldError('fax')" class="inlineError" v-html="getFieldError('fax')"></span>
                                <input-check type="text" id="fax" class="faxInput code" @on-input-change="change()" name="fax" maxlength="15" size="18" v-model="pt400Request.fax" :disabled="pt400Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false"/>
                                <!--項目説明マスタ[16]-->
                                <div v-html="pt400Init.descriptionInfo['16']"></div>
                            </div>
                        </div>
                        <!-- 担当者情報1~3 ユニコカスタマイズ項目 -->
                        <template v-for="i in 3">
                            <div class="tantoushaLine" v-if="checkUnico(0)"  :key="i">
                                <div class="label">
                                    <label v-if="i == 1" class="required" :id="'unicoTantousha'+i+'_lbl'">
                                        <span>{{$t('pt400.labels.tantousha')+i}}</span>
                                    </label>
                                    <label v-else :class="pageType == PAGE_INSERT?'optional':'verticalAlignTop'" :id="'unicoTantousha'+i+'_lbl'">
                                        <span>{{$t('pt400.labels.tantousha')+i}}</span>
                                    </label>
                                </div>
                                <div class="input">
                                    <!-- 担当者名 -->
                                    <span v-if="pt400Init.errorMsgFlg == 1 && getFieldError('unicoTantoushaNm'+i)" class="inlineError unicoTantoushaNmError" v-html="getFieldError('unicoTantoushaNm'+i)"></span>
                                    <label :for="'unicoTantousha'+i+'_disp_lbl'" :id="'unicoTantoushaNm'+i+'_disp_lbl'">{{$t('pt400.labels.name3B')}}</label>
                                    <input-check type="text" :id="'unicoTantoushaNm'+i" :class="'unicoTantoushaNm'+i+'Input'" :name="'unicoTantoushaNm'+i" @on-input-change="change()" maxlength="50" size="25" v-model="pt400Request[`unicoTantoNm${i}`]"/>
                                    <!-- 担当者名カナ -->
                                    <label :for="'unicoTantoushaKana'+i+'_disp_lbl'" :id="'unicoTantoushaKana'+i+'_disp_lbl'">{{$t('pt400.labels.name3KanaB')}}</label>
                                    <input-check type="text" :id="'unicoTantoushaKana'+i" :class="'unicoTantoushaKana'+i+'Input'" :name="'unicoTantoushaKana'+i" @on-input-change="change()" maxlength="50" size="25" v-model="pt400Request[`unicoTantoKana${i}`]"/>
                                    <!-- 担当者電話番号 -->
                                    <label :for="'unicoTantoushaTel'+i+'_disp_lbl'" :id="'unicoTantoushaTel'+i+'_disp_lbl'">{{$t('pt400.labels.tantoushaTel')}}</label>
                                    <input-check type="text" :id="'unicoTantoushaTel'+i" :class="'unicoTantoushaTel'+i+'Input code'" :name="'unicoTantoushaTel'+i" @on-input-change="change()" maxlength="50" size="18" v-model="pt400Request[`unicoTantoTel${i}`]"/>

                                    <!-- エラーメッセージ用ラベル -->
                                    <label :for="'unicoTantousha'+i+'_lbl'" :id="'unicoTantoushaNm'+i+'_lbl'" hidden>{{$t('pt400.labels.name3B')+i}}</label>
                                    <label :for="'unicoTantoushaKana'+i+'_lbl'" :id="'unicoTantoushaKana'+i+'_lbl'" hidden>{{$t('pt400.labels.name3KanaB')+i}}</label>
                                    <label :for="'unicoTantoushaTel'+i+'_lbl'" :id="'unicoTantoushaTel'+i+'_lbl'" hidden>{{$t('pt400.labels.tantoushaTel')+i}}</label>
                                </div>
                            </div>
                        </template>
                        <!--支払方法-->
                        <div class="kessaiNameLine" v-if="pt400Init.siteFlg == 1 && pt400Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE == 1">
                            <div class="label">
                                <label class="optional" id="kessaiCd_lbl">
                                    <span>{{$t('pt400.labels.kessaiName')}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <select v-model="pt400Request.kessaiCd" class="kenCdSelect" id="kessaiCd" name="kessaiCd" @change="change()"> 
                                    <option v-for="kessaiCd in pt400Init.kessaiCdListBySeikyuKbn" :key="kessaiCd.KEY" :value="kessaiCd.KEY">{{kessaiCd.VALUE}}</option>
                                </select>
                            </div>
                        </div>
                        <!-- 生年月日-->
                        <div class="birthLine" v-if="pt400Init.siteKbn != 'B' && pt400Init.btobFlg == 0">
                            <div class="label" >
                                <label :class="pt400Init.birthdayUpdateFlg == 0?'optional':''" id="birthDay_lbl">
                                    <span>{{$t('common.labels.birthday')}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <template v-if="pt400Init.birthdayUpdateFlg == 0">
                                    <input-check type="text" id="birthDayYYYY" class="birthYearInput numcode" @on-input-change="change()" name="birthDay_YYYY" maxlength="4" size="7" v-model="pt400Request.birthDayYYYY" :disabled="pt400Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false"/>
                                    <span class="birthYear">{{$t('common.labels.year')}}</span>
                                    <select v-model="pt400Request.birthDayMM" name="birthDay_MM" class="birthMonthSelect" @change="change()" :disabled="pt400Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false">
                                        <option></option>
                                        <template v-for="mm in 12" >
                                            <option v-if="mm < 10" :key="mm" :value="'0'+mm">{{'0'+mm}}</option>
                                            <option v-else :key="mm" :value="mm">{{mm}}</option>
                                        </template>
                                    </select>
                                    <span class="birthMonth">{{$t('common.labels.month')}}</span>
                                    <select v-model="pt400Request.birthDayDD" name="birthDay_DD" class="birthDaySelect" @change="change()" :disabled="pt400Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false">
                                        <option></option>
                                        <template v-for="dd in 31" >
                                            <option v-if="dd < 10" :key="dd" :value="'0'+dd">{{'0'+dd}}</option>
                                            <option v-else :key="dd" :value="dd">{{dd}}</option>
                                        </template>
                                    </select>
                                    <span class="birthDay">{{$t('common.labels.day')}}</span>
                                    <!--項目説明マスタ[28]-->
                                    <div v-html="pt400Init.descriptionInfo['17']"></div>
                                </template>
                                <template v-else>
                                    {{pt400Request.birthDayYYYY}}年
                                    {{pt400Request.birthDayMM}}月
                                    {{pt400Request.birthDayDD}}日
                                </template>
                            </div>
                        </div>
                        <!--性別-->
                        <div class="sexLine" v-if="pt400Init.siteKbn != 'B' && pt400Init.btobFlg == 0">
                            <div class="label">
                                <label :class="pt400Init.sexUpdateFlg == 0?'optional':''" id="sexKbn_lbl">
                                    <span>{{$t('common.labels.sex')}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <template v-if="pt400Init.sexUpdateFlg == 0">
                                    <div class="sexKbn">
                                        <input type="radio" class="sexKbn1Input" name="sexKbn" @change="change()" value="1" v-model="pt400Request.sexKbn" id="sexKbn_0" :disabled="pt400Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false">
                                        <label for="sexKbn_0">{{$t('common.labels.male')}}</label>
                                        <input type="radio" class="sexKbn2Input" name="sexKbn" @change="change()" value="2" v-model="pt400Request.sexKbn" id="sexKbn_1" :disabled="pt400Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false">
                                        <label for="sexKbn_1">{{$t('common.labels.female')}}</label>
                                        <input type="radio" class="sexKbn3Input" name="sexKbn" @change="change()" value="9" v-model="pt400Request.sexKbn" id="sexKbn_2" :disabled="pt400Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false">
                                        <label for="sexKbn_2">{{$t('common.labels.unspecified')}}</label>
                                        <!--項目説明マスタ[18]-->
                                        <div v-html="pt400Init.descriptionInfo['18']"></div>
                                    </div>
                                </template>
                                <template v-else>
                                    <div v-if="pt400Request.sexKbn =='1'">{{$t('common.labels.male')}}</div>
                                    <div v-else-if="pt400Request.sexKbn =='2'">{{$t('common.labels.female')}}</div>
                                    <div v-else >{{$t('common.labels.unspecified')}}</div>
                                </template>
                            </div>
                        </div>
                        <!--メルマガ-->
                        <div class="mailMgLine" v-if="pt400Init.mailMgDispFlg == 1">
                            <div class="label">
                                <label class="required" id="mailMg_lbl">
                                    <span>{{$t('pt400.labels.emailMagazine')}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <input type="radio" name="newsMailRcvFlg" value="0" class="newsMailRcvFlg0Input" @change="change()" v-model="pt400Request.newsMailRcvFlg" id="newsMailRcvFlg_1" :disabled="pt400Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false">
                                <label for="newsMailRcvFlg_1">{{$t('pt400.labels.doNotWant')}}</label>
                                <input type="radio" name="newsMailRcvFlg" value="1" class="newsMailRcvFlg1Input" @change="change()" v-model="pt400Request.newsMailRcvFlg" id="newsMailRcvFlg_0" :disabled="pt400Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false">
                                <label for="newsMailRcvFlg_0">{{$t('pt400.labels.toWish')}}</label>
                                <!--項目説明マスタ[19]-->
                                <div v-html="pt400Init.descriptionInfo['19']"></div>
                            </div>
                        </div>
                        <!--DM-->
                        <div class="dmNgFlgLine" v-if="pt400Init.mailMgDispFlg == 1">
                        <div class="label">
                            <label class="required" id="dmNgFlg_lbl">
                            <span>{{$t('pt400.labels.dmNgFlg')}}</span>
                            </label>
                        </div>
                        <div class="input">
                            <input type="radio" name="dmNoFlg" value="0" class="dmNoFlg0Input" @change="change()" v-model="pt400Request.dmFlg" id="dmNoFlg_1" :disabled="pt400Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false">
                            <label for="dmNoFlg_1">{{$t('pt400.labels.doNotWant')}}</label>
                            <input type="radio" name="dmNoFlg" value="1" class="dmNoFlg1Input" @change="change()" v-model="pt400Request.dmFlg" id="dmNoFlg_0" :disabled="pt400Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false">
                            <label for="dmNoFlg_0">{{$t('pt400.labels.toWish')}}</label>
                        </div>
                        </div>
                        <!-- チラシ -->
                        <div class="flierNgFlgLine" v-if="pt400Init.flierNgFlg == 1">
                            <div class="label">
                                <label class="required" id="flierNgFlg_lbl">
                                    <span>{{$t('pt400.labels.flierNgFlg')}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <input type="radio" name="flierNgFlg" value="0" class="flierNgFlg0Input" @change="change()" v-model="pt400Request.flierNgFlg" id="flierNgFlg_1" :disabled="pt400Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false">
                                <label for="flierNgFlg_1">{{$t('pt400.labels.doNotWant')}}</label>
                                <input type="radio" name="flierNgFlg" value="1" class="flierNgFlg1Input" @change="change()" v-model="pt400Request.flierNgFlg" id="flierNgFlg_0" :disabled="pt400Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false">
                                <label for="flierNgFlg_0">{{$t('pt400.labels.toWish')}}</label>
                            </div>
                        </div>
                        <!--ニックネーム -->
                        <div class="nicknameLine" v-if="pt400Init.siteKbn != 'B' && !(pt400Init.entetsuFlg == 1 && pageType == PAGE_INSERT)">
                            <div class="label">
                                <label class="optional" id="nickname_lbl">
                                    <span>{{$t('pt400.labels.nickname')}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <span v-if="pt400Init.errorMsgFlg == 1 && getFieldError('nickname')" class="inlineError" v-html="getFieldError('nickname')"></span>
                                <input-check type="text" class="nicknameInput" @on-input-change="change()" id="nickname" name="nickname" maxlength="10" size="18" v-model="pt400Request.nickname" :disabled="pt400Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false"/>
                                <!--項目説明マスタ[23]-->
                                <div v-html="pt400Init.descriptionInfo['23']"></div>
                            </div>
                        </div>
                        <!--年齢 -->
                        <div class="ageLine" v-if="pt400Init.siteKbn != 'B' && !(pt400Init.entetsuFlg == 1 && pageType == PAGE_INSERT)">
                            <div class="label">
                                <label class="optional" id="age_lbl">
                                    <span>{{$t('pt400.labels.age')}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <input type="radio" class="ageOpenFlg1Input" name="ageOpenFlg" value="1" @change="change()" v-model="pt400Request.ageOpenFlg" id="age_Koukai_1" :disabled="pt400Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false">
                                <label for="age_Koukai_1">{{$t('pt400.labels.koukai1')}}</label>
                                <input type="radio" class="ageOpenFlg0Input" name="ageOpenFlg" value="0" @change="change()" v-model="pt400Request.ageOpenFlg" id="age_Koukai_0" :disabled="pt400Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false">
                                <label for="age_Koukai_0">{{$t('pt400.labels.koukai2')}}</label>
                            </div>
                        </div>
                        <!--性別 -->
                        <div class="sexDispLine" v-if="pt400Init.siteKbn != 'B' && !(pt400Init.entetsuFlg == 1 && pageType == PAGE_INSERT)">
                            <div class="label">
                                <label class="optional" id="sexDisp_lbl">
                                    <span>{{$t('common.labels.sex')}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <input type="radio" class="sexOpenFlg1Input" name="sexOpenFlg" value="1" @change="change()" v-model="pt400Request.sexOpenFlg" id="sex_Koukai_1" :disabled="pt400Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false">
                                <label for="sex_Koukai_1">{{$t('pt400.labels.koukai1')}}</label>
                                <input type="radio" class="sexOpenFlg0Input" name="sexOpenFlg" value="0" @change="change()" v-model="pt400Request.sexOpenFlg" id="sex_Koukai_0" :disabled="pt400Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false">
                                <label for="sex_Koukai_0">{{$t('pt400.labels.koukai2')}}</label>
                            </div>
                        </div>
                        <!--顧客グループ-->
                        <div class="kenLine" v-if="pt400Init.customerGroupFlg == 1 && pt400Init.siteKbn == 'B'">
                            <div class="label">
                                <label class="required" id="customerGroup_lbl">
                                    <span>{{pt400Init.analysisTitle}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <span v-if="pt400Init.errorMsgFlg == 1 && getFieldError('customerGroup')" class="inlineError" v-html="getFieldError('customerGroup')"></span>
                                <select v-model="pt400Request.customerGroup" @change="change()"  class="customerGroup"  id="customerGroup" name="customerGroup" :disabled="pt400Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false"> 
                                    <option v-for="cusGroup in pt400Init.customerGroupList" :key="cusGroup.KEY" :value="cusGroup.KEY">{{cusGroup.VALUE}}</option>
                                </select>
                            </div>
                        </div>
                        <div class ="companyline" v-if="pt400Init.companyNmFlg == 1">
                            <!--会社名-->
                            <div class="label">
                                <label class="required" id="companyNm_lbl">
                                    <span>{{pt400Init.analysisTitle2}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <span v-if="pt400Init.errorMsgFlg == 1 && getFieldError('companyNm')" class="inlineError" v-html="getFieldError('companyNm')"></span>
                                <select v-model="pt400Request.companyNm" @change="change()"  class="companyNm"  id="companyNm" name="companyNm" :disabled="pt400Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false"> 
                                    <option v-for="companyNm in pt400Init.companyList" :key="companyNm.KEY" :value="companyNm.KEY">{{companyNm.VALUE}}</option>
                                </select>
                            </div>
                        </div>
                        <div class ="busyoNm" v-if="pt400Init.companyNmFlg == 1">
                            <div class="label">
                                <label class="required" id="busyoNm_lbl">
                                    <span>{{$t('pt400.labels.busyoNm')}}</span>
                                </label>
                            </div>
                            <!--部署名・協力会社-->
                            <div class="input">
                                <span v-if="pt400Init.errorMsgFlg == 1 && getFieldError('busyoNm')" class="inlineError" v-html="getFieldError('busyoNm')"></span>
                                <input-check type="text" id="busyoNm" class="busyoNm" @on-input-change="change()" name="busyoNm" maxlength="50" size="18" v-model="pt400Request.busyoNm" :disabled="pt400Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false"/>       
                            </div>
                        </div>
                        <!-- 定休日 ユニコカスタマイズ項目 -->
                        <div class="teikyubiLine" v-if="checkUnico(1)">
                            <div class="label">
                                <label class="required" id="teikyubi_lbl">
                                    <span>{{$t('pt400.labels.teikyubi')}}</span>
                                </label>
                            </div>
                            <div class="input">                        
                                <template v-for="(data, index) in unicoTeikyubiList">
                                    <span v-if="pt400Init.errorMsgFlg == 1 && getFieldError('teikyubiChk_'+index)" class="inlineError" v-html="getFieldError('teikyubiChk_'+index)"></span>
                                    <span :key="index" :id="'teikyubi_'+index" :class="'mr-3 teikyubi_'+index">
                                        <label :id="'teikyubiChk_'+index+'_lbl'" hidden>{{$t('pt400.labels.teikyubi')}}</label>
                                        <input type="checkbox" :id="'teikyubiChk_'+index" class="mr-1 teikyubiChk" name="teikyubiChk" v-model="unicoTeikyubi[index]">
                                        <label :for="'teikyubiChk_'+index">{{data}}</label>
                                    </span>
                                </template>
                            </div>
                        </div>
                        <!-- 営業時間 ユニコカスタマイズ項目 -->
                        <div class="eigyojikan" v-if="checkUnico(1)">
                            <div class="label">
                                <label class="required" id="eigyojikan_lbl">
                                    <span>{{$t('pt400.labels.eigyojikan')}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <div class="eigyojikanFrom">
                                    <select v-model="unicoEigyojikanFromHH" class="eigyojikanSelectHH" id="eigyojikanFromHH" name="eigyojikanFromHH"> 
                                        <option v-for="eigyojikanFromHH in unicoEigyojikanHH" :key="eigyojikanFromHH.KEY" :value="eigyojikanFromHH.KEY">{{eigyojikanFromHH.VALUE}}</option>
                                    </select>
                                    <span>{{$t('common.labels.colon')}}</span>
                                    <select v-model="unicoEigyojikanFromMI" class="eigyojikanSelectMI" id="eigyojikanFromMI" name="eigyojikanFromMI"> 
                                        <option v-for="eigyojikanFromMI in unicoEigyojikanMI" :key="eigyojikanFromMI.KEY" :value="eigyojikanFromMI.KEY">{{eigyojikanFromMI.VALUE}}</option>
                                    </select>
                                </div>
                                <span>{{$t('common.labels.fromTo')}}</span>
                                <div class="eigyojikanTo">
                                    <select v-model="unicoEigyojikanToHH" class="eigyojikanSelectHH" id="eigyojikanToHH" name="eigyojikanToHH"> 
                                        <option v-for="eigyojikanToHH in unicoEigyojikanHH" :key="eigyojikanToHH.KEY" :value="eigyojikanToHH.KEY">{{eigyojikanToHH.VALUE}}</option>
                                    </select>
                                    <span>{{$t('common.labels.colon')}}</span>
                                    <select v-model="unicoEigyojikanToMI" class="eigyojikanSelectMI" id="eigyojikanToMI" name="eigyojikanToMI"> 
                                        <option v-for="eigyojikanToMI in unicoEigyojikanMI" :key="eigyojikanToMI.KEY" :value="eigyojikanToMI.KEY">{{eigyojikanToMI.VALUE}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <!-- シェフマル段ボール ユニコカスタマイズ項目 -->
                        <div class="reuseBox" v-if="checkUnico(0)">
                            <div class="label">
                                <label class="required" id="reuseBox_lbl">
                                    <span>{{$t('pt400.labels.reuseBox')}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <input type="radio" name="reuseBox" value="1" class="reuseBox0Input" @change="change()" v-model="pt400Request.unicoReuseBox" id="reuseBox_1">
                                <label for="reuseBox_1">{{$t('pt400.labels.radioOk')}}</label>
                                <input type="radio" name="reuseBox" value="0" class="reuseBox1Input" @change="change()" v-model="pt400Request.unicoReuseBox" id="reuseBox_0">
                                <label for="reuseBox_0">{{$t('pt400.labels.radioNg')}}</label>
                            </div>
                        </div>
                    </div>
                    
                    <!--会員規約-->
                    <div class="membership" v-if="pageType == PAGE_INSERT && pt400Init.entetsuFlg != 1">
                        <div class="membershipAgreement">{{$t('pt400.labels.membership')}}</div>
                        <div class="membershipDescription" v-html="pt400Init.descriptionInfo['40']"></div>
                        <div class="AgreeFlag">
                            <!--同意する-->
                            <input type="radio" id="AgreeFlag1" name="AgreeFlag" value="1" class="AgreeFlag1Input" v-model="pt400Request.agreeFlag">
                            <label for="AgreeFlag1">{{$t('pt400.labels.agreeItems')}}</label>
                            <!-- 規約に同意しない -->
                            <input type="radio" id="AgreeFlag0" name="AgreeFlag" value="0" class="AgreeFlag0Input" v-model="pt400Request.agreeFlag">
                            <label for="AgreeFlag0">{{$t('pt400.labels.dontAgree')}}</label>
                        </div>
                    </div>
                    <div class="membership" v-if="pageType == PAGE_INSERT && pt400Init.entetsuFlg == 1">
                         <div class="AgreeFlag">
                            <div class="membershipDescription" v-html="pt400Init.descriptionInfo['41']"></div>
                            <!--同意する-->
                            <input type="radio" id="AgreeFlag1" name="AgreeFlag" value="1" class="AgreeFlag1Input" v-model="pt400Request.agreeFlag">
                            <label for="AgreeFlag1">{{$t('pt400.labels.agreeItems')}}</label>
                            <!-- 規約に同意しない -->
                            <input type="radio" id="AgreeFlag0" name="AgreeFlag" value="0" class="AgreeFlag0Input" v-model="pt400Request.agreeFlag">
                            <label for="AgreeFlag0">{{$t('pt400.labels.dontAgree')}}</label>
                        </div>
                    </div>
                    <!--プライバシーポリシーリンク-->
                    <p class="noteLink" v-if="!(pt400Init.entetsuFlg == 1 && pageType == PAGE_INSERT)">
                        <span v-html="pt400Init.descriptionInfo['21']"></span>
                        <router-link class="blank" target="_blank" :to="{ name: SiteConstants.PG010MAIN, query:{ pageNo:70}}">
                            {{$t('common.labels.noteLink')}}
                        </router-link>
                        <span v-html="pt400Init.descriptionInfo['22']"></span>
                    </p>
                    <!--新規登録かつ直接登録ではなく仮顧客マスタに登録する設定の場合-->
                    <p class="syoninMessage" v-if="pageType == PAGE_INSERT && pt400Init.syouninOption == 1">
                        <span class="center" v-html="pt400Init.descriptionInfo['53']"></span>
                    </p>
                    <!--戻るボタン-->
                    <div id="btn_roll3" v-if="pageType == PAGE_UPDATE && pt400Init.backButtonFlg == 1">
                        <router-link :to="generateLinkParams(81,pt400Init.myPage)" class="btnCancel">
                            {{$t('common.buttons.return')}}
                        </router-link>
                    </div>
                    <!--登録ボタン-->
                    <div id="btn_roll2" v-if="pageType == PAGE_INSERT">
                        <a class="btnSubmit" @click="confirmDoInsert()">{{$t('common.buttons.signup')}}</a>
                    </div>
                    <!--更新ボタン-->
                    <div id="btn_roll2" v-if="pageType == PAGE_UPDATE && !isUpdateFlg">
                        <a class="btnDisable">{{$t('common.buttons.update')}}</a>
                    </div>
                    <div id="btn_roll2" v-if="pageType == PAGE_UPDATE && isUpdateFlg">
                        <a class="btnSubmit" @click="confirmDoUpdate()">{{$t('common.buttons.update')}}</a>
                    </div>
                </template>

                </template>
            </div><!--/ .section-inner -->
            <!-- modal confirm area -->
            <!--アラート表示-->
            <alert-confirm
                v-if="isModalShow"
                :msgConfirm="msgConfirm"
                :okAction="doAction"
                :isButtonCancel="isButtonCancel">
            </alert-confirm>
            <CC212InputPostal v-if="cc212Dislay" @modal-close="cc212Dislay = false" :propTdkZip1="dataCc212.propTdkZip1" 
            :propTdkZip2="dataCc212.propTdkZip2" :propIdx="dataCc212.propIdx" @set-addr-value="setAddrValue" />
        </div>
    </div>
</template>


<script>
/* eslint-disable */
/*
* Import libs and componnents
*/
import $ from 'jquery';
import axios from "assets/js/request";
import common from 'assets/js/common';
import EventBus from 'assets/js/eventBus';
import Message from 'components/MessageEcSite';
import Loading from 'vue-loading-overlay';
import InputCheck from 'components/InputCheck.vue';
import AlertConfirm from 'components/AlertConfirm';
import SiteConstants from 'assets/const/SiteConstants.json';
import Breadcrumb from "../commonParts/Breadcrumb.vue";
import toastr from "toastr/toastr.js";
import "toastr/build/toastr.min.css";
import CC212InputPostal from '../search/CC212InputPostal';

toastr.options = {
  closeButton: true,
  positionClass: "toast-top-right",
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "3000",
};

export default {
    /*
    * Name of component
    */
    name: "PT400MemberInfoParts",
    props:{
        ptInitData: {
            type: Object,
            default: null,
        },
        ptInitCommonData: {
            type: Object,
            default: null,
        },
    },
    /*
    * Declare components
    */
    components: {
        Message: Message,
        Loading,
        InputCheck,
        AlertConfirm,
        Breadcrumb,
        toastr,
        CC212InputPostal
    },
    /*
    * Declare variable and set default value
    */
    data: function() {
        return {
            PT400_PART: 'pt400',
            common:common,
            isLoading: false,
            isDisplay: false,
            pt400Init: {
                orderInfo:{},
                realAuthoriFlg: 1,
                descriptionInfo:{},
                backButtonFlg: 0,
                entetsuFlg: 0,
                entetsuKohojinFlg: 0,
                memberInfoCheckOpyionFlg:0,
                errorMsgFlg: 0
            },
            pt400Request: {
                agreeFlag:0,
                //zip:null,
                zip1:null,
                zip2:null,
                //addr1:null,
                //addr2:null,
                //addr3:null,

                mail: null,
                mailOld: null,
                mail_confirm: null,
                password: null,
                passwordSub: null,
                prePassword: null,
                nm1: null,
                nm2: null,
                kana1: null,
                kana2: null,
                birthDayYYYY: null,
                birthDayMM: null,
                birthDayDD: null,
                sexKbn: null,
                zip: null,
                kenCd: null,
                addr1: null,
                addr2: null,
                addr3: null,
                tel1: null,
                tel2: null,
                fax: null,
                newsMailRcvFlg: null,
                kokyakuRankKbn: null,
                kokyakuRankKbnNm: null,
                pointNum: null,
                exclCnt: null,
                nickname: null,
                ageOpenFlg: null,
                sexOpenFlg: null,
                kaiinCheck: null,
                authUuid: null,
                ikoPassword: null,
                ikoPasswordSub: null,
            },
            isButtonCancel: true,
            actionFlg:0,
            koumokuList:'',
            zeiKbnNm:'',
            isModalShow:false,
            listIdErr:[],
            SiteConstants: SiteConstants,
            PAGE_INSERT:'3',
            PAGE_UPDATE:'4',
            tdkNum:4,
            pageType:3,
            isModalShow:false,
            msgConfirm:'',
            listMessValid:[],
            mapMessValid:[],
            isButtonOK:false,
            cc212Dislay:false,
            dataCc212: {},
            cc212ReqModel:{},
            tdkIndex:null,
            site: "",
            mailMessage1:"",
            mailMessage2:"",
            isUpdateFlg: false,
            report: "",
            isAddr23Flg: false,
            isMailAuthSendFlg: false,
            isMailAuthErr: false,

            unicoCognitionDtlFlg: false,
            unicoCognitionDtlInfo1: "",
            unicoCognitionDtlInfo2: "",
            unicoTeikyubiList: ['月', '火', '水', '木', '金', '土', '日', '不定休', '祝', 'なし'],
            unicoTeikyubi: [],
            unicoEigyojikanHH: [],
            unicoEigyojikanMI: [],
            unicoEigyojikanFromHH: "00",
            unicoEigyojikanFromMI: "00",
            unicoEigyojikanToHH: "00",
            unicoEigyojikanToMI: "00",
            pt400params: {},
            ikoPasswordDispFlg: 0,
            isErrorFlg: 0,
            updateCheckFlg: 0,
            passwordView: "",
            pt406backFlg: false,
            pt406reqmodel: {}

        }
    },
    /*
    * 初期処理
    */
    mounted: function() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];

        // メール認証利用の場合、、認証の有効チェックを行う
        if (_this.pt400Request.authUuid){
            _this.checkMailAuth();
        }

        if (_this.ptInitData){
            _this.pt400Init = _this.ptInitData;
            _this.pt400Request = Object.assign({}, _this.pt400Request, _this.ptInitData.reqModel);
        }else{
            axios.get(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT400 + _this.$UrlConstants.DO_INIT,_this.pt400Request).then(function(response) {
                _this.pt400Init = response.data;
                _this.pt400Request = Object.assign({}, _this.pt400Request, response.data.reqModel);
                // 確認画面から戻った場合、入力データで上書きする
                if (_this.pt406backFlg && _this.pt406reqmodel && Object.keys(_this.pt406reqmodel).length > 0) {
                    _this.pt400Request = Object.assign({}, _this.pt400Request, _this.pt406reqmodel);
                }
            }).catch(function(error) {
                common.errorAPI(error);
            });
        }
        // ログイン済の場合
        if(_this.pt400Init.isLogin == true){
            _this.pageType = 4;
        }
        // 会員規約のセット
        var splInfo = _this.pt400Init.descriptionInfo['40'];
        if (splInfo != null && splInfo.length > 0) {
            splInfo = splInfo.split('\n');
            var des20 = '';
            for(var i = 0; i < splInfo.length; i++){
                des20 = des20.concat(splInfo[i] + '<br>');
            }
            _this.pt400Init.descriptionInfo['40'] = des20;
        }
        // エラー情報がある場合
        if(_this.pt400Init.errList != null && _this.pt400Init.errList.length > 0){
            _this.displayWarning(_this.pt400Init.errList);
        }
        // メールに関する注意事項１
        if(_this.pt400Init.descriptionInfo[2] != undefined){
            _this.mailMessage1 = _this.pt400Init.descriptionInfo[2];
            _this.mailMessage1 = _this.mailMessage1.replace("{0}",_this.pt400Init.siteMail)
        }
        // メールに関する注意事項２
        if(_this.pt400Init.descriptionInfo[3] != undefined){
            _this.mailMessage2 = _this.pt400Init.descriptionInfo[3];
            _this.mailMessage2 = _this.mailMessage2.replace("{0}",_this.pt400Init.siteMail)
        }

        if (_this.pt400Init.entetsuKohojinFlg == 1 && _this.pageType == _this.PAGE_INSERT){
            if (common.isNullItem(_this.pt400params.cardKaiinFlg)){
                if (sessionStorage.getItem('kaiin')){
                    _this.pt400params = Object.assign({}, JSON.parse(sessionStorage.getItem('kaiin')));
                }
            }
            sessionStorage.removeItem('kaiin');
            
            if (_this.pt400params.cardKaiinFlg != null && _this.pt400params.cardKaiinFlg !== ''){
                if (_this.pt400params.kenCd){
                    const found = _this.pt400Init.kenCdList.find(item => item.VALUE === _this.pt400params.kenCd);
                    _this.pt400params.kenCd = found ? found.KEY : null;
                }
                _this.pt400Request = Object.assign({}, _this.pt400Request, _this.pt400params);
            }
            if (_this.pt400params.existsFlg == 0){
                _this.ikoPasswordDispFlg = 1;
            }else{
                _this.ikoPasswordDispFlg = 0;
            }

            //遠鉄 cookie存在チェック
            if (_this.entetsuCookieCheck()){
                console.log("cookieがないです!!!");
            }
        }

        _this.pt406backFlg = _this.$route.query.pt406backFlg;
        if (_this.pt406backFlg){
            const pt406RequestStr = sessionStorage.getItem('pt406Request');
            if (pt406RequestStr) {
                _this.pt406reqmodel = JSON.parse(pt406RequestStr);
                sessionStorage.removeItem('pt406Request');
            }
            _this.pt400Request = Object.assign({}, _this.pt400Request, _this.pt406reqmodel);
            if (_this.pt400Init.unicoCusFlg == 1) {
                _this.unicoCognitionDtlFlg = true;
                _this.unicoEigyojikanFromHH = _this.pt400Request.unicoEigyojikanFromHH;
                _this.unicoEigyojikanFromMI = _this.pt400Request.unicoEigyojikanFromMI;
                _this.unicoEigyojikanToHH = _this.pt400Request.unicoEigyojikanToHH;
                _this.unicoEigyojikanToMI = _this.pt400Request.unicoEigyojikanToMI;
                _this.unicoTeikyubi = Array(_this.unicoTeikyubiList.length).fill(false);
                if (_this.pt400Request.unicoTeikyubi) {
                    const indices = _this.pt400Request.unicoTeikyubi.split(',');
                    indices.forEach(idx => {
                        const n = Number(idx);
                        if (!isNaN(n) && n >= 0 && n < _this.unicoTeikyubiList.length) {
                            _this.unicoTeikyubi[n] = true;
                        }
                    });
                }
                _this.unicoCognitionChg(2);
            }
        }

        for (var i=0; i<_this.unicoTeikyubiList.length; i++){
            _this.unicoTeikyubi.push(false);
        }
        for (var i=0; i<24; i++){
            var hh = ('0' + i).slice(-2);
            _this.unicoEigyojikanHH.push({KEY: hh, VALUE: hh});
        }
        for (var i=0; i<60; i++){
            var mi = ('0' + i).slice(-2);
            _this.unicoEigyojikanMI.push({KEY: mi, VALUE: mi});
        }

        //POPUPを閉じるイベント
        EventBus.$on('closed', function() {
            _this.isModalShow = false;
            _this.isAddr23Flg = false;
        });
    },
    /*
    * メソッド
    */
    methods: {
        /*
        * 住所２/住所３が利用するそして必須チェック利用が確認する時でメッセージを戻る
        */
        getAddr23Msg: function(){
            let msg = "";
            if ((this.pt400Init.addr2Flg == 1 && this.pt400Init.addr2HissuFlg == 2 && this.pt400Request.addr2 == "") || 
                (this.pt400Init.addr3Flg == 1 && this.pt400Init.addr3HissuFlg == 2 && this.pt400Request.addr3 == "")) {

                let subMsg2 = this.$i18n.t('pt400.labels.lessAddress');
                let subMsg3 = this.$i18n.t('common.labels.optionLabel');

                if ((this.pt400Init.addr2Flg == 1 && this.pt400Init.addr2HissuFlg == 2 && this.pt400Request.addr2 == "") &&  
                    (this.pt400Init.addr3Flg == 1 && this.pt400Init.addr3HissuFlg == 2 && this.pt400Request.addr3 == "")){
                    msg = this.$i18n.t('pt400.labels.messg7').replace("{0}", subMsg2 + "と" + subMsg3);
                }else{
                    if (this.pt400Init.addr2Flg == 1 && this.pt400Init.addr2HissuFlg == 2 && this.pt400Request.addr2 == ""){
                        msg = this.$i18n.t('pt400.labels.messg7').replace("{0}", subMsg2);
                    }
                    if (this.pt400Init.addr3Flg == 1 && this.pt400Init.addr3HissuFlg == 2 && this.pt400Request.addr3 == ""){
                        msg = this.$i18n.t('pt400.labels.messg7').replace("{0}", subMsg3);
                    }
                }
            }
            return msg;
        },
        /*
        * 登録ボタン押下処理（メールアドレス認証）
        */
        confirmDoAuth: function(){
            this.msgConfirm = this.$i18n.t('pt400.labels.messg8')
            this.isModalShow = true;
            this.isButtonCancel = true;
            this.actionFlg = 5;
        },
        /*
        * 登録ボタン押下処理
        */
        confirmDoInsert: function(){
            // 同意ラジオボタン
            if(this.pt400Request.agreeFlag != 1){
                // 規約に同意いただける場合のみ会員登録することができます。
                this.msgConfirm = this.$i18n.t('pt400.labels.messg1')
                this.isModalShow = true;
                this.isButtonCancel = false;
                this.actionFlg = -1;
                return;
            }

            // ユニコカスタマイズ項目チェック
            if (this.checkUnico(0)) {
                /////////////////////////////
                // 備考作成
                /////////////////////////////
                this.pt400Request.unicoBikou = "";
                // 営業許可番号
                this.pt400Request.unicoBikou += this.$i18n.t('pt400.labels.eigyokyoNo') + ":" + this.pt400Request.unicoEigyokyoNo + "\n";
                var teikyubiTxt = "";
                var teikyubiNum = "";
                for (var i=0; i<this.unicoTeikyubi.length; i++){
                    if (this.unicoTeikyubi[i]){
                        teikyubiTxt += this.unicoTeikyubiList[i] + ",";
                        teikyubiNum += i + ",";
                    }
                }
                if (teikyubiTxt != ""){
                    teikyubiTxt = teikyubiTxt.slice(0, -1);
                }
                if (teikyubiNum != ""){
                    teikyubiNum = teikyubiNum.slice(0, -1);
                }
                // 定休日
                this.pt400Request.unicoTeikyubi = teikyubiTxt;
                this.pt400Request.unicoBikou += this.$i18n.t('pt400.labels.teikyubi') + ":" + teikyubiTxt + "\n";
                // 営業時間
                this.pt400Request.unicoEigyojikanFrom = this.unicoEigyojikanFromHH + this.unicoEigyojikanFromMI;
                this.pt400Request.unicoEigyojikanTo = this.unicoEigyojikanToHH + this.unicoEigyojikanToMI;
                this.pt400Request.unicoBikou += this.$i18n.t('pt400.labels.eigyojikan') + ":" + this.unicoEigyojikanFromHH + ":" + this.unicoEigyojikanFromMI
                                                 + "～" + this.unicoEigyojikanToHH + ":" + this.unicoEigyojikanToMI + "\n";
                // 知ったきっかけ
                var cognitionTxt = "";
                for (var i=0; i<this.pt400Init.unicoCognitionList.length; i++){
                    if (this.pt400Init.unicoCognitionList[i].KEY == this.pt400Request.unicoCognition){
                        cognitionTxt = this.pt400Init.unicoCognitionList[i].VALUE;
                        break;
                    }
                }
                this.pt400Request.unicoBikou += "【" + this.$i18n.t('pt400.labels.cognition') + ":" + cognitionTxt + "】\n";
                if (this.pt400Request.unicoCognitionDtlTitle1) {
                    this.pt400Request.unicoBikou += "【" + this.pt400Request.unicoCognitionDtlTitle1 + ":" + this.pt400Request.unicoCognitionDtlValue1 + "】\n";
                }
                if (this.pt400Request.unicoCognitionDtlTitle2) {
                    this.pt400Request.unicoBikou += "【" + this.pt400Request.unicoCognitionDtlTitle2 + ":" + this.pt400Request.unicoCognitionDtlValue2 + "】\n";
                }

                // 確認画面用にセット
                this.pt400Request.yobiStr1 = this.pt400Request.unicoEigyokyoNo;
                this.pt400Request.yobiStr2 = this.pt400Request.unicoCognitionDtlTitle1;
                this.pt400Request.yobiStr3 = this.pt400Request.unicoCognitionDtlValue1;
                this.pt400Request.yobiStr4 = this.pt400Request.unicoCognitionDtlTitle2;
                this.pt400Request.yobiStr5 = this.pt400Request.unicoCognitionDtlValue2;
                this.pt400Request.yobiStr6 = this.pt400Request.unicoTeikyubi;
                this.pt400Request.yobiStr7 = teikyubiNum;
                this.pt400Request.yobiCd1 = this.unicoEigyojikanFromHH;
                this.pt400Request.yobiCd2 = this.unicoEigyojikanFromMI;
                this.pt400Request.yobiCd3 = this.unicoEigyojikanToHH;
                this.pt400Request.yobiCd4 = this.unicoEigyojikanToMI;
            }

            // 住所２/住所３が利用するそして必須チェック利用が確認する時でメッセージを戻る
            let msg = this.getAddr23Msg();
            if (msg != "" && !this.isAddr23Flg){
                this.msgConfirm = msg;
                this.isModalShow = true;
                this.isButtonCancel = true;
                this.actionFlg = 3;
                this.isAddr23Flg = true;
                return;
            }
            
            //遠鉄 cookie存在チェック
            if (this.entetsuCookieCheck()){
                console.log("cookieがないです!!!");
                return;
            }
            
            if (this.pt400Init.memberInfoCheckOpyionFlg == 1){
                if (this.isAddr23Flg){
                    this.isAddr23Flg = false;
                    this.$nextTick(() => {
                        this.isAddr23Flg = false;
                        this.actionFlg = 6;
                        this.doAction();
                    });
                } else {
                    this.actionFlg = 6;
                    this.doAction();
                }               
            } else {
                if (this.isAddr23Flg){
                    this.isAddr23Flg = false;
                    this.$nextTick(() => {
                        this.isAddr23Flg = false;
                        this.msgConfirm = this.$i18n.t('pt400.labels.messg2');
                        this.isModalShow = true;
                        this.isButtonCancel = true;
                        this.actionFlg = 1;
                    });
                } else {
                    this.msgConfirm = this.$i18n.t('pt400.labels.messg2')
                    this.isModalShow = true;
                    this.isButtonCancel = true;
                    this.actionFlg = 1;
                }
            }
        },
        /*
        * 認証メール送信処理
        */
        doMailAuth: function(){
            var _this = this;
            _this.$emit("event-loading", true);
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.PT400_PART);
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT400 + _this.$UrlConstants.DO_CONFIRM, _this.pt400Request).then(function(response) {
                if(response.data.status == 'OK'){
                    // 認証メール送信完了にする
                    _this.isMailAuthSendFlg = true;
                }
                // エラーがあった場合
                if(response.data.errList != null && response.data.errList.length > 0){
                    _this.displayWaring(response.data.errList);
                }
                _this.$emit("event-loading", !true);
            }).catch(function(error) {
                _this.$emit("event-loading", !true);
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, _this.PT400_PART);
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            common.scrollTop();
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },
        /*
        * メールアドレス認証確認処理
        */
        checkMailAuth: function() {
            var _this = this;
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT400 + _this.$UrlConstants.DO_AJAX, _this.pt400Request).then(function(response) {
                if(response.data.status == 'OK'){
                    // 認証OKにする
                    _this.isMailAuthErr = false;
                    if (response.data.response.mailAddr) {
                        // メールアドレスを認証したもので固定する。
                        _this.pt400Request.mail = response.data.response.mailAddr;
                    }
                } else {
                    // 認証エラーにする
                    _this.isMailAuthErr = true;
                }
            }).catch(function(error) {
                _this.$emit("event-loading", !true);
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, _this.PT400_PART);
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            common.scrollTop();
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },
        /*
        *  登録処理
        */
        doInsert: function(){
            var _this = this;
            _this.$emit("event-loading", true);
            //clear msg valid
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.PT400_PART);
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT400 + _this.$UrlConstants.DO_INSERT, _this.pt400Request).then(function(response) {
                var fromCart = _this.pt400Request.fromCart != null? _this.pt400Request.fromCart:'';
                if(response.data.status == 'OK'){
                    sessionStorage.setItem('pt400Request', JSON.stringify(_this.pt400Request));
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 12, fromCart:fromCart}});
                }
                // エラーがあった場合
                if(response.data.errList != null && response.data.errList.length > 0){
                    _this.displayWaring(response.data.errList);
                }
                _this.$emit("event-loading", !true);
            }).catch(function(error) {
                _this.$emit("event-loading", !true);
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, _this.PT400_PART);
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            common.scrollTop();
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },

        /*
        * 更新ボタン押下処理
        */
        confirmDoUpdate: function(){
            // 住所２/住所３が利用するそして必須チェック利用が確認する時でメッセージを戻る
            let msg = this.getAddr23Msg();
            if (msg != "" && !this.isAddr23Flg){
                this.msgConfirm = msg;
                this.isModalShow = true;
                this.isButtonCancel = true;
                this.actionFlg = 4;
                this.isAddr23Flg = true;
                return;
            }
            if (this.pt400Init.memberInfoCheckOpyionFlg == 1){
                if (this.isAddr23Flg){
                    this.isAddr23Flg = false;
                    this.$nextTick(() => {
                        this.isAddr23Flg = false;
                        this.updateCheckFlg = 1;
                        this.actionFlg = 6;
                        this.doAction();
                    });
                }else{
                    this.updateCheckFlg = 1;
                    this.actionFlg = 6;
                    this.doAction();
                }
            } else {
                if (this.isAddr23Flg){
                    this.isAddr23Flg = false;
                    this.$nextTick(() => {
                        this.isAddr23Flg = false;
                        this.msgConfirm = this.$i18n.t('pt400.labels.messg3')
                        this.isModalShow = true;
                        this.isButtonCancel = true;
                        this.actionFlg = 2;
                    });
                }else{
                    this.msgConfirm = this.$i18n.t('pt400.labels.messg3')
                    this.isModalShow = true;
                    this.isButtonCancel = true;
                    this.actionFlg = 2;
                }
            }
        },
        // ルーターリンクパラメータ設定
        generateLinkParams(pageNo, customUrl, additionalQuery = {}, additionalParams = {}) {
            return common.routerLinkParams(pageNo, customUrl, additionalQuery, additionalParams);
        },
        /*
        *  更新処理
        */
        doUpdate: function(){
            var _this = this;
            _this.$emit("event-loading", true);
            var report = '';
            //clear msg valid
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.PT400_PART);
            var tdkList = _this.pt400Request.tdkList;
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT400 + _this.$UrlConstants.DO_UPDATE, _this.pt400Request).then(function(response) {
                if(response.data.status == 'OK'){
                    if(response.data.response != null){
                        // 更新完了メッセージ
                        report = response.data.response.message;
                        toastr.success(report);
                        
                        _this.pt400Request.exclCnt = response.data.response.exclCnt;
                        _this.pt400Request.mailOld = response.data.response.mailOld;
                        // マイメニュー画面へ遷移
                        const parameter = _this.generateLinkParams(81,_this.pt400Init.myPage);
                        _this.$router.push(parameter);
                    }
                }
                // エラー表示
                if(response.data.errList != null && response.data.errList.length > 0){
                    _this.displayWaring(response.data.errList);
                }
                _this.$emit("event-loading", !true);
            }).catch(function(error) {
                _this.$emit("event-loading", !true);
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, _this.PT400_PART);
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            common.scrollTop();
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },
        /*
        * 入力項目を変更した場合更新ボタンをアクティブにする
        */
        change: function() {
            var _this = this;
            _this.isUpdateFlg = true;
        },
        /*
        * インライン表示用：指定フィールドのエラーメッセージを返す
        * @fieldId: input の id 属性値
        * @return: エラーメッセージ文字列（なければ null）
        */
        getFieldError: function(fieldId) {
            if (!this.mapMessValid || this.mapMessValid.length === 0) return null;
            for (var i = 0; i < this.mapMessValid.length; i++) {
                if (this.mapMessValid[i].key === fieldId) {
                    return this.mapMessValid[i].mess;
                }
            }
            return null;
        },
        /*
        * チェックが付いたら重複チェックを行う
        */
        check: function() {
            var _this = this;
            _this.$emit("event-loading", true);
            //clear msg valid
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.PT400_PART);
            if(_this.pt400Request.kokyakuCd == null || _this.pt400Request.kokyakuCd == undefined || _this.pt400Request.kokyakuCd == ''){
                _this.pt400Request.kaiinCheck = 2;
                _this.$emit("event-loading", !true);
            } else {
                axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT400 + _this.$UrlConstants.DO_CHECK, _this.pt400Request).then(function(response) {
                    _this.pt400Request.kaiinCheck = response.data;
                    // エラーがあった場合
                    if(response.data.errList != null && response.data.errList.length > 0){
                        _this.displayWaring(response.data.errList);
                    }
                    _this.$emit("event-loading", !true);
                }).catch(function(error) {
                    _this.$emit("event-loading", !true);
                    if(error != null && error != undefined){
                        if(error.response != null && error.response != undefined){
                            if(406 == error.response.status){
                                var resultValid = common.excuteValidationEcSite(error, _this.PT400_PART);
                                if(resultValid){
                                    _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                    _this.listMessValid = resultValid.msgList;
                                    _this.mapMessValid = resultValid.mapMsg;
                                    _this.pt400Request.kaiinCheck = 1;
                                }
                                common.scrollTop();
                            }else{
                                common.errorAPI(error);
                            }
                        }
                    }
                });
            }
        },
         /*
        *  POPUP表示処理 actionFlg
        * 1: 登録処理
        * 2: 更新処理
        * 6: 確認画面用ワーク登録
        */
        doAction: function(){
            var _this = this;
            switch (_this.actionFlg) {
                case 1:
                    _this.doInsert();
                    break;
                case 2:
                    _this.doUpdate();
                    break;
                case 3:
                    _this.isAddr23Flg = true;
                    _this.confirmDoInsert();
                    break;
                case 4:
                    _this.isAddr23Flg = true;
                    _this.confirmDoUpdate();
                    break;
                case 5:
                    _this.doMailAuth();
                    break;
                case 6:
                    _this.workInput();
                    break;
                default:
                    break;
            }
            // Hide alert confirm
            _this.isModalShow = false;
            _this.actionFlg = 0;
            _this.isButtonCancel = true;
        },
        /* 
        * Function excuteValidation 
        * analyst data message and display
        */
        displayWarning(errorList){
            var idList  = [];
            var mapMsg = [];
            var msgList = [];
            var listIdErr = [];
            // check error list
            if(errorList != null && errorList.length > 0){
                //var errorList = error.response.data.errorList;
                for(var index =0;  index < errorList.length; index ++){
                    // row of table
                    var rowTableIndex = errorList[index].rowTableIndex == undefined ? -1 : errorList[index].rowTableIndex;
                    // zoneIndex
                    var zoneIndex = errorList[index].zoneIndex == undefined ? -1 : errorList[index].zoneIndex;

                    // set border-color for input
                    var listGroupId = errorList[index].groupId;
                    if(listGroupId != null && listGroupId.length > 0){
                        for (var keyInx = 0; keyInx < listGroupId.length; keyInx++){
                            var idInput = listGroupId[keyInx];
                            var inputObj = $('#' + idInput);
                            if(inputObj != null && inputObj != undefined){
                                inputObj.css('border-color', "red");
                            }

                            listIdErr.push(idInput);
                        }
                    }

                    // replace messenge
                    var messageList = errorList[index].messageList;
                    if(messageList != null && messageList.length > 0){
                        for (var mesInx = 0; mesInx < messageList.length; mesInx++){
                            var msgTemp = messageList[mesInx].message;
                            var argList =messageList[mesInx].argList;
                            if(argList != null && argList.length > 0){
                                
                                for(var arg=0; arg<argList.length; arg++){
                                    // get lable display of item input 
                                    var idInput = $('#'+ argList[arg] + '_lbl');
                                    var label ='';

                                    if(idInput != null && idInput != undefined){
                                        label =  idInput.text();
                                    }
                                    // replace text for key to display
                                    if(rowTableIndex > -1){
                                        if(label.length > 0){
                                            msgTemp = msgTemp.replace('{' + argList[arg] + '}', label).replace('{rowIndex}', rowTableIndex);   
                                        }else{
                                            msgTemp = msgTemp.replace('{' + argList[arg] + '}', label);   
                                        }
                                    }else{
                                        if(label.length > 0){
                                            msgTemp = msgTemp.replace('{' + argList[arg] + '}', label);   
                                        }
                                    }
                                }
                            }
                            // if message not include key(message common)
                            if(listGroupId != null && listGroupId.length > 0){
                                var obj ={};
                                obj.key = listGroupId[0];
                                obj.mess= msgTemp;
                                mapMsg.push(obj);
                            }else{
                                msgList.push(msgTemp);
                            }
                            
                        }
                    }
                }

                // emit message to componet message
                var msg ={};
                msg.listMess = msgList;
                msg.mapMsg = mapMsg;
                EventBus.$emit('message', msg);
                return listIdErr;
            }
        },
        /*
        * 住所検索処理
        */
        addrAutoInput: function(tdkIndex){
            var _this = this;
            _this.tdkIndex = tdkIndex;
            var zip = _this.pt400Request.zip;

            if(_this.tdkIndex != 'kokyaku'){
                zip = _this.pt400Request.tdkList[tdkIndex].tdkZip;
            }

            // 空の場合
			if ( common.isNullItem(zip) ) {
				if (_this.isModalShow != true){
					_this.isModalShow = true;
				}
				// 郵便番号は必須です。
				_this.msgConfirm =_this.$i18n.t('sh030.labels.zipCodeIsMandatory');
				_this.isButtonCancel = true;
				_this.isButtonOK = false;
				return;
			}
			var zipArr = zip.split("-");
			var zip1 = "";
			var zip2 = "";
            // 7桁以上の場合
            if ( zip.length >= 7 ) {
                // ハイフンが含まれている場合
                if ( zip.includes("-") ) {
                    zip1 = zipArr[0];
                    zip2 = zipArr[1];
                    // 3桁-4桁でない場合はエラー
                    if (zip1.length != 3 && zip2.length != 4) {
                        _this.msgConfirm = _this.$t("sh030.labels.zipCodeDoesNotExist");
                        _this.isModalShow = true;
                        return;
                    }
                // ハイフンが含まれていない場合
                } else {
                    zip1 = zip.substring(0,3);
                    zip2 = zip.substring(3,7);
                
                    _this.pt400Request.zip = zip1 + "-" + zip2;
                }
            } else {
                return;
            }
			
			_this.cc212ReqModel.tdkZip1 = zip1;
			_this.cc212ReqModel.tdkZip2 = zip2;
			_this.$emit("event-loading", true);
			axios.post(_this.$UrlConstants.POPUP + _this.$UrlConstants.CC212 + _this.$UrlConstants.GET_ADDR_INFO, _this.cc212ReqModel).then(function(response) {
				if (response.data.allAddr == 'juufuku'){
					_this.dataCc212.propTdkZip1 = zip1;
					_this.dataCc212.propTdkZip2 = zip2;
					_this.cc212Dislay = true;
				}
				else {
					_this.setAddr(response.data.allAddr ,response.data.kenCd,response.data.kenNm, zip1 ,zip2,tdkIndex);
				}
				_this.$emit("event-loading", !true);
			}).catch(function(error) {
				_this.$emit("event-loading", !true);
				common.errorAPI(error);
			});
		},
		// 住所検索Ajaxの戻り
		// パラメータの_addrに「住所,町名番地,建物名・部屋番号」の形で戻ってくる(30文字ずつ)
		setAddr: function (addr, kenCd , kenNm, zip1 , zip2, tdkIndex){
            var _this = this;
            var sp = new Array("","","");
			if (addr) {
                sp = addr.split(",");
                var displayAddr = sp[0]==null?'':sp[0] ;
                displayAddr += sp[1]==null?'':sp[1];
                displayAddr += sp[2]==null?'':sp[2];

                if(_this.tdkIndex == 'kokyaku'){
                    //都道府県のプルダウンを使用しない場合
                    if(_this.pt400Init.kenPulldownDispFlg == 0){
                        _this.pt400Request.addr1 = kenNm + displayAddr;
                    }else{
                        _this.pt400Request.addr1 = displayAddr;
                    }
                    _this.pt400Request.kenCd = kenCd;
                    _this.pt400Request.zip = zip1+ "-" +zip2;
                } else{
                    //都道府県のプルダウンを使用しない場合
                    if(_this.pt400Init.kenPulldownDispFlg == 0){
                        _this.pt400Request.tdkList[_this.tdkIndex].tdkAddr1 = kenNm + displayAddr;
                    }else{
                        _this.pt400Request.tdkList[_this.tdkIndex].tdkAddr1 = displayAddr;
                    }
                    _this.pt400Request.tdkList[_this.tdkIndex].tdkKenCd = kenCd;
                    _this.pt400Request.tdkList[_this.tdkIndex].tdkZip = zip1+ "-" +zip2;
                }
				_this.$forceUpdate();
			}else{
				if (_this.isModalShow != true){
					_this.isModalShow = true;
				}
				// 郵便番号が存在しません
				_this.msgConfirm =_this.$i18n.t('sh030.labels.zipCodeDoesNotExist');
				_this.pt400Request.zip= '';
				_this.isButtonCancel=true;
				_this.isButtonOK=false;
			}
		},
        setAddrValue:function(data){
            var _this = this;
            var addr1 = data.addr.ALL_ADDR?data.addr.ALL_ADDR:"";
            
            var kenCd = data.kenCd+"";
            //都道府県のプルダウンを使用しない場合
            if(_this.pt400Init.kenPulldownDispFlg == 0){
                _this.pt400Request.addr1 = addr1;
            }else{
                _this.pt400Request.addr1 = _this.outKenNm(kenCd,addr1);
            }
            _this.pt400Request.kenCd = kenCd;
            _this.isCCInputPostalShow = false;
            _this.$forceUpdate();
        },
        /*
        * 都道府県名を削除
        */
        outKenNm :function(kenCd,addr) {
            var kenList = this.pt400Init.kenCdList;
            for ( var i = 0; kenList.length > i; i++) {
                if(kenList[i].KEY == kenCd) {
                    return  addr.replace(kenList[i].VALUE,"");
                }
            }
        },

        /*
        * ユニコカスタマイズ項目用チェック
        */
        checkUnico(insertOnlyFlg) {
            var _this = this;
            var res = false;
            if (_this.pt400Init.unicoCusFlg == 1) {
                if (insertOnlyFlg == 1) {
                    if (_this.pageType == _this.PAGE_INSERT) {
                        res = true;
                    }
                } else {
                    res = true;
                }
            }
            return res;
        },
        /*
        * ユニコカスタマイズ 知ったきっかけの入力欄チェック
        */
       unicoCognitionChg(data) {
            var _this = this;
            _this.unicoCognitionDtlFlg = false;
            _this.unicoCognitionDtlInfo1 = "";
            _this.unicoCognitionDtlInfo2 = "";
            _this.pt400Request.unicoCognitionDtlTitle1 = "";
            _this.pt400Request.unicoCognitionDtlTitle2 = "";
            if (data == 1) {
                _this.pt400Request.unicoCognitionDtlValue1 = "";
                _this.pt400Request.unicoCognitionDtlValue2 = "";
            }
            // ユニコカスタマイズがON
            if (_this.checkUnico(0)) {
                // 選択されていて、「WEBサイト・ネットから検索」以外のとき表示
                if (_this.pt400Request.unicoCognition && _this.pt400Request.unicoCognition != '03' && _this.pt400Request.unicoCognition != '') {

                    switch (_this.pt400Request.unicoCognition) {
                        case '01':
                            _this.pt400Request.unicoCognitionDtlTitle1 = _this.$i18n.t('pt400.labels.cognitionCatalogId');
                            _this.unicoCognitionDtlInfo1 = _this.$i18n.t('pt400.labels.cognitionCatalogIdInfo');
                            break;
                        case '02':
                            _this.pt400Request.unicoCognitionDtlTitle1 = _this.$i18n.t('pt400.labels.cognitionMagazine');
                            break;
                        case '04':
                            _this.pt400Request.unicoCognitionDtlTitle1 = _this.$i18n.t('pt400.labels.cognitionIntroduce1');
                            _this.pt400Request.unicoCognitionDtlTitle2 = _this.$i18n.t('pt400.labels.cognitionIntroduce2');
                            break;
                        case '05':
                            _this.pt400Request.unicoCognitionDtlTitle1 = _this.$i18n.t('pt400.labels.cognitionBeforeStore1');
                            _this.pt400Request.unicoCognitionDtlTitle2 = _this.$i18n.t('pt400.labels.cognitionBeforeStore2');
                            break;
                        default:
                            break;
                    }

                    _this.unicoCognitionDtlFlg = true;
                }
            }
       },

        /*
        * 遠鉄 cookie存在チェック
        */
        entetsuCookieCheck(){
            let result = false;

            if (this.pt400Init.entetsuKohojinFlg == 1 && common.isNullItem(this.pt400Request.kaiNo)){
                this.isErrorFlg = 1;

                this.listMessValid = [];
                this.mapMessValid = [];
                common.clearMessageEcSite(this.listIdErr, this.PT400_PART);
                this.listMessValid.push(this.$i18n.t('entetsu.messages.apiResultErrMsg'));
                common.scrollTop();
                result = true;
            }

            return result;
        },

        /*
        * 確認画面用ワーク登録
        */
        workInput(){
            var _this = this;

            _this.isAddr23Flg = false;
            _this.$emit("event-loading", true);
            _this.passwordView = _this.pt400Request.password ? '●'.repeat(_this.pt400Request.password.length) : '';
            let req = Object.assign({}, _this.pt400Request, { updateCheckFlg: _this.updateCheckFlg });
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT400 + _this.$UrlConstants.DO_INPUT, req).then(function(response) {
                if(response.data.status == 'OK'){
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 30}, params: { exclCnt: _this.pt400Request.exclCnt, passwordView: _this.passwordView }});
                }
                // エラーがあった場合
                if(response.data.errList != null && response.data.errList.length > 0){
                    __this.displayWaring(response.data.errList);
                }
                _this.$emit("event-loading", !true);
            }).catch(function(error) {
                _this.$emit("event-loading", !true);
                    if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, _this.PT400_PART);
                            if(resultValid){
                            _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                            _this.listMessValid = resultValid.msgList;
                            _this.mapMessValid = resultValid.mapMsg;
                            }
                            common.scrollTop();
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },
        /* フォーカス時にreadonly属性を除去してブラウザの自動入力を防止*/
        removeReadonly: function(event){
            event.target.removeAttribute('readonly');
        }
    },
    beforeDestroy() {
        EventBus.$off('closed');
        EventBus.$off('is-loading');
    },
    /*
    * Excute code after an instance is created
    */
    created: function(){
         var _this = this;
        // Get data from params and query
        var queryData = _this.$route.query;
        if (Object.keys(queryData).length > 0){
            _this.pt400Request.authUuid = queryData.uuid;
        }
        let params = _this.$route.params;
        if (params){
            _this.pt400params = Object.assign({}, params);
        }
    }
}
</script>

<style scoped>
/* インラインエラーメッセージ */
.inlineError {
    display: block;
    font-size: 13px;
    font-weight: bold;
    margin-bottom: 4px;
    color: #dc3545;
}

</style>